export default {
  //Item photo
  Photo: "Photo",
  ChoosePhoto: "Choisir une photo",
  RemovePhoto: "Supprimer la photo",
  //Order panel
  CurrentOrder: "Commande en cours",
  NoItemsYet: "Aucun article",
  TapAnItemToAddIt: "Touchez un article pour l'ajouter à la commande",
  //Login
  SetOwnerPin: "FRSet Owner Pin",
  SetPin: "FRSet Pin",
  EnterValidName: "FREnter Valid Name",
  PinMustBeExactly4Characters: "FRPin must be exactly 4 characters",
  PinCodeDoesNotMatch: "FRPin Code Does Not Match",
  //Drawer
  Sales: "FRSales",
  Receipts: "FRReceipts",
  Listings: "FRListings",
  Shift: "FRShift",
  ShiftReports: "FRShift Reports",
  Settings: "FRSettings",
  LogoutAttendant: "FRLogout Attendant",

  //Sales
  Subtotal: "FRSubtotal",
  Tax: "FRTax",
  Discounts: "FRDiscounts",
  TotalPayment: "FRTotal Payment",
  Favorites: "FRFavorites",
  All: "FRAll",
  Payment: "FRPayment",
  ItemFavorites: "FRItem Favorites",
  WouldYouLikeToIncludeTheItemAsFavorites:
    "FRWould you like to include the item as favorite?",
  WouldYouLikeToRemoveTheItemAsFavorites:
    "FRWould you like to remove the item as favorite?",
  EditPrice: "FREdit Price",
  SetPrice: "FRSet Price",
  EditTransactionLine: "FREdit Transaction Line",
  Quantity: "FRQuantity",
  SetQuantity: "FRSet Quantity",
  Set: "FRSet",
  SetCommission: "FRSet Commission",
  Add: "FRAdd",
  ReceiptLineIsDeleted: "FRReceipt Line is Deleted",
  Okay: "FROkay",
  ItIsNotYourShift: "FRIt is not your shift",

  //Sales Delete Icon
  ConfirmDelete: "FRConfirm Delete",
  AreYouSureToDeleteReceiptLines: "FRAre you sure to delete receipt lines?",
  No: "FRNo",
  Yes: "FRYes",

  //Sales Discount Icon
  Discount: "FRDiscount",
  PleaseAddAnItem: "FRPlease add an item",
  OK: "FROK",
  OnTheFlyDiscount: "FROn The Fly Discount",
  ExistingDiscount: "FRExisting Discount",
  DiscountType: "FRDiscount Type",
  Percentage: "FRPercentages",
  SetDiscount: "FRSet Discount",
  FixDiscount: "FRFix Discount",
  CurrentDiscountSelected: "FRCurrent Discount Selected",
  NoSelectedDiscount: "FRNoSelectedDiscount",
  SelectNewDiscount: "FRSelect New Discount",

  //Sales Search
  SearchItems: "FRSearch Items",

  //Sales View Orders
  ViewOrders: "FRView Orders",
  NoOrdersYet: "FRNo Orders Yet",
  ConfirmOrder: "FRConfirm Order",
  SelectOrderType: "FRSelect Order Type",
  Cancel: "FRCancel",
  Confirm: "FRConfirm",
  AnyPendingTransactionsWillBeOverridedWouldYouLikeToContinue:
    "FRAny Pending Transactions Will Be Overrided. Would you like to continue?",
  Orders: "FROrders",
  ORDER: "FRORDER",
  CancelOrder: "FRCancel Order",
  TableNo: "FRTable No",
  TableNumber: "FRTable Number",
  ChangeTable: "FRChange Table",
  ReprintOrder: "FRReprint Order",

  //Payment
  Pay: "FRPay",
  AmountDue: "FRAmount Due",
  AmountChange: "FRAmount Change",
  Customer: "FRCustomer",
  PaymentType: "FRPayment Type",
  PrinterStatus: "FRPrinterStatus",
  NoDefaultPrinter: "FRNo Default Printer",
  AddCustomer: "FRAddCustomer",
  Cash: "FRCash",
  Card: "FRcard",
  ConfirmPayment: "FRConfirm Payment",
  AreYouSure: "FRAre you sure?",
  Proceed: "FRProceed",
  ReceiptInformation: "FRReceipt Information",
  DoYouWantToPrintReceipt: "FRDo you want to print receipt",
  Close: "FRClose",
  TransactionSummary: "FRTransaction Summary",
  CashPaid: "FRCash Paid",
  Commission: "FRCommission",
  Alert: "FRAlert",
  AmountPaidMustBeGreaterThanOrEqualToAmuntDue:
    "FRAmount Paid must be greater than or equal to Amount Due",
  Email: "FREmail",
  PhoneNumber: "FRPhone Number",
  Note: "FRNote",
  Save: "FRSave",
  NoAddedPrinterDevice: "FRNo added printer device",

  //Receipt
  NoReceiptsAvailable: "FRNo receipts available",
  Receipt: "FRReceipt",
  Completed: "FRCompleted",
  Attendant: "FRAttendant",
  Offline: "FROffline",
  Reprint: "FRReprint",
  CancelReceipt: "FRCancel Receipt",
  SoldTo: "FRSold to",
  Total: "FRTotal",
  NoTax: "FRNo tax",
  NoDiscount: "FRNo discount",
  AmountPaid: "FRAmount Paid",
  Transaction: "FRTransaction",
  VoidReceipt: "FRVoid Receipt",
  AreYouSureYouWantToVoidReceipt: "FRAre you sure you want to void receipt?",
  Reason: "FRReason",
  Cancelled: "FRCancelled",

  //Listings
  Items: "FRItems",
  Item: "FRItem",

  Categories: "FRCategories",
  WouldYouLikeToCreateNewItem: "FRWould you like to create new item?",
  WouldYouLikeToCreateNewCategory: "FRWould you like to create new category?",
  WouldYouLikeToCreateNewDiscount: "FRWould you like to create new discount?",
  CreateNewItem: "FRCreate new item",
  CreateNewCategory: "FRCreate new category",
  CreateNewDiscount: "FRCreate new discount",

  //Listings Items
  Category: "FRCategory",
  NoCategory: "FRNo Category",
  Price: "FRPrice",
  Barcode: "FRBarcode",
  SoldBy: "FRSold by",
  Each: "FREach",
  Weight: "FRWeight",
  OtherInformation: "FROther Information",
  SKU: "FRSKU",
  StockKeepingUnit: "FRStock Keeping Unit",
  Color: "FRColor",
  Shape: "FRShape",
  ShowOptions: "FRShow Options",
  PrintBarcode: "FRPrint Barcode",
  HideOptions: "FRHide Options",
  SaveNewItem: "FRSave new item",
  SuccessfullyAddedNewItem: "FRSuccessfully added new item",

  //Listings categories
  CategoryName: "FRCategory Name",
  ColorWillApplyToAllItemsUnderThisCategoryForWhichColorIsNotSet:
    "FRColor will apply to all items under this category for which color is not set",
  SaveNewCategory: "FRSave new category",
  EnterValidCategoryName: "FREnter Valid Category Name",
  EnterValidDiscountName: "FREnter Valid Discount Name",
  EnterAValidItemName: "FREnter a Valid Item Name",
  EnterValidDiscountValue: "FREnter Valid Discount Value",
  SuccessfullyAddedCategory: "FRSuccessfully Added Category",
  SuccessfullyAddedDiscount: "FRSuccessfully Added Discount",

  //Listings Discounts
  DiscountName: "FRDiscount Name",
  DiscountValue: "FRDiscount Value",
  Role: "FRRole",

  //Shift
  InputValidReason: "FRInput valid reason",
  AddedCash: "FRAdded Cash",
  CashPayoutIsGreaterThanTheCashAvailable:
    "FRCash Payout is greater than the cash available",
  RemovedCash: "FRRemoved Cash",
  ShiftDetails: "FRShift details",
  Amount: "FRAmount",
  Payin: "FRPay-in",
  Payout: "FRPay-out",
  ShiftStarted: "FRShift started",
  ShiftStartedOn: "FRShift started on",
  BeginningCash: "FRBeginning Cash",
  EndingCash: "FREnding Cash",
  ShiftOpenedBy: "FRShift opened by",
  CloseShift: "FRClose Shift",
  TheCashYouWantedToPutIntoTheRegisterOrGetOutFromTheRegister:
    "FRThe cash you wanted to pur into the register or get out grom the register.",
  ActualMoney: "FRActualMoney",
  SetActualMoney: "FRSet Actual Money",
  InvalidAmount: "FRInvalid Amount",
  EndedShift: "FREnded Shift",
  WorkedFor: "FRWorked for",
  AndEndedOn: "FRand ended on",
  StartAnotherShift: "FRStart Another Shift",
  TheCashByTheStartOfTheShift: "FRThe cash by the start of the shift",
  EnterABeginningCash: "FREnter a beginning cash",

  //Shift Reports

  ItemSalesReport: "FRItems Sales Report",
  CommissionReport: "FRCommission Report",
  GenerateZReading: "FRGenerate Z Reading",
  NoZReadingGenerated: "FRNo Z Reading Generated",
  ZReading: "FRZ Reading",
  Opened: "FROpened",
  By: "FRby",
  TotalNetSales: "FRTotal Net Sales",
  Transactions: "FRTransactions",
  OpeningAmount: "FROpening Amount",
  ExpectedDrawer: "FRExpected Drawer",
  Short: "FRShort",
  CashSales: "FRCash Sales",
  Payouts: "FRPayouts",
  Payins: "FRPay Ins",
  Taxes: "FRTaxes",
  Commissions: "FRCommissions",
  PrintXReport: "FRPrint X Report",
  ShiftInfo: "FRShift Info",
  PrintReport: "FRPrint Report",
  PrintCommissions: "FRPrint Commissions",
  Name: "FRName",
  PrintZReport: "FRPrint Z Report",

  //Settings
  //Bluetooth
  Bluetooth: "FRBluetooth",
  Company: "FRCompany",
  Sync: "FRSync",
  Queueing: "FRQueueing",
  Printer: "FRPrinter",
  RegisteredDevices: "FRRegistered Devices",
  AvailableDevices: "FRAvailable Devices",
  BluetoothScanner: "FRBluetooth Scanner",
  Enable: "FREnable",
  Connected: "FRConnected",
  Connecting: "FRConnecting...",
  NotConnected: "FRNot Connected",
  AddDevice: "FRAdd Device",
  AreYouSureYouWantToAddThisDevice:
    "FRAre you sure you want to add this device?",
  AreYouSureYouWantToRemoveThisDevice:
    "FRAre you sure you want to remove this device?",
  SuccessfullyAddedDevice: "FRSuccessfully Added Device",
  SuccessfullyRemovedDevice: "FRSuccessfully Removed Device",
  RemoveDevice: "FRRemove Device",

  //Company
  CompanySettings: "FRCompany Settings",
  Currency: "FRCurrency",
  CompanyHeader: "FRCompany Header",
  CompanyFooter: "FRCompany Footer",
  CurrentlyEditingPleaseSaveYourChanges:
    "FRCurrently editing. Please save your changes",

  //Attendant
  AddRole: "FRAdd Role",
  AttendantName: "FRAttendant Name",
  CanLogin: "FRCan Login",
  SaveAttendant: "FRSave Attendant",
  Pin: "FRPin",
  ConfirmPin: "FRConfirm Pin",
  SuccessfullyAddedAttendant: "FRSuccessfully Added Attendant",
  EnterValidPin: "FREnter Valid Pin",
  PleaseConfirmPin: "FRPlease Confirm Pin",

  //Sync
  Server: "FRServer",
  SyncSettings: "FRSync Settings",
  Username: "FRUsername",
  Password: "FRPassword",
  DeviceID: "FRDevice ID",
  PleaseClickTheEditButton: "FRPlease click the edit (pencil icon) button",
  EnterValidAttendantName: "FREnter Valid Attendant Name",
  //Queueing
  OtherSettings: "FROther Settings",
  UseDescription: "FRUse Description",
  DescriptiveItemNamesInTheListing: "FRDescriptive item names in the listing",
  UseDefaultCustomer: "FRUse Default Customer",
  SetItemStacking: "FRSet Item Stacking",
  Use: "FRUse",
  EnableThe: "FREnable the",
  Feature: "FRfeature",
  HostAddress: "FRHost Address",

  //Logout
  ConfirmLogout: "FRConfirm Logout",
  AreYouSureYouWantToLogout: "FRAre you sure you want to logout?",

  //Select Attendant
  SelectAttendant: "FRSelect Attendant",
  Next: "FRNext",
  None: "FRNone",
  EnterPin: "FREnter PIN",
  NoAttendant: "FRNo Attendant",
  PleaseSelectAnyAttendant: "FRPlease Select Any Attendant",
  PINError: "FRPIN Error",
  PleaseEnterTheCorrectPINNumber: "FRPlease enter the correct PIN number",

  //Late Additionals
  SetTheShift: "FRSet the shift",
  AttendantAlreadyAdded: "FRAttendant Already Added",
  NoItemBasedOnTheBarcode: "FRNo item based on the barcode",
  QuantityIsNotAllowed: "FRQuantity is not allowed",
  ReceiptLineIsModified: "FRReceipt line is modified",
  UnableToDeleteReceiptLine: "FRUnable to delete receipt line.",
  ConfirmOrderCancel: "FRConfirm Order Cancel",
  ConfirmOrderClose: "FRConfirm Order Close",
  WouldYouLikeToCancelTheOrder: "FRWould you like to cancel the order?",
  WouldYouLikeToCloseTheOrder: "FRWould you like to close the order?",
  IsCancelled: "FRis cancelled",
  Order: "FROrder",
  ConfirmTableChange: "FRConfirm Table Change",
  WouldYouLikeToChangeTable: "FRWould you like to change table?",
  TableNumberChanged: "FRTable Number Changed",
  UnableToTakeAwayOrder: "FRUnable to take-away order.",
  SaveNew: "FRSave new",
  Edit: "FREdit",
  VerifyCode: "FRVerify code",
  Verify: "FRVerify",
  ResendCode: "FRResend Code",
  CashedOut: "FRCashed Out",
  TaxPercentage: "FRTax Percentage",
  ItemName: "FRItem Name",
  AddNewItem: "FRAdd new item",
  WouldYouLikeToCreateNew: "FRWould you like to create new",
  CreateNew: "FRCreate new",
  From: "FRFrom",
  To: "FRTo",
  EnterPinCode: "FREnter PIN Code",
  ZeroPriceIsNotAvailable: "FRZero price is not available.",
  PaymentReceipt: "FRPayment Receipt",
  TransactedOn: "FRTransacted on",
  YouHaveSuccessfullyRegistered: "FRYou have successfully registered",
  ReceiptItems: "FRReceipt Items",
  Overage: "FROverage",
  ErrorButton: "FRError Button",
  ForceSync: "FRForce Sync",
  SyncingErpnextData: "FRSyncing ERPNEXT data",
  SendPassword: "FRSend Password",
  Back: "FRBack",
  Register: "FRRegister",
  Login: "FRLogin",
  CreateAccount: "FRCreate Account",
  FirstName: "FRFirst Name",
  LastName: "FRLast Name",
  ConfirmPassword: "FRConfirm Password",
  ThereAreItemsAssociatedWithThisCategoryChangeOrDeleteTheItems:
    "FRThere are items associated with this category. Change or delete the items",
  SuccessfullyDeletedCategory: "FRSuccessfully Deleted Category",
  SuccessfullyDeletedItem: "FRSuccessfully Deleted Item",
  SuccessfullyDeletedDiscount: "FRSuccessfully Deleted Discount",
  DeleteCategory: "FRDelete Category?",
  DeleteItem: "FRDelete Item?",
  DeleteDiscount: "FRDelete Discount?",
  WouldYouLikeToDeleteThisCategory: "FRWould you like to delete this category?",
  WouldYouLikeToDeleteAnItem: "FRWould you like to delete an item?",
  WouldYouLikeToDeleteThisDiscount: "FRWould you like to delete this discount?",
  SuccessfullyUpdatedCategory: "FRSuccessfully Updated Category",
  SuccessfullyUpdatedItem: "FRSuccessfully Updated Item",
  SuccessfullyUpdatedDiscount: "FRSuccessfully Updated Discount",
  DiscountValueError: "FRDiscount Value Error",
  ValueCantBeGreaterThan100OrLessThan0:
    "FRValue cant be greater than 100% or less than 0%",
  BarcodeAlreadyBeenUsed: "FRBarcode already been used",
  EnterValidItemName: "FREnter Valid Item Name",
  SuccessfullyPrintedTheBarcode: "FRSuccessfully printed the barcode.",
  UnableToPrint: "FRUnable to print",
  PleaseConnectYourPrinter: "FRPlease connect your printer",
  CheckYourEmail: "FRCheck Your Email.",
  NetworkConnectionFailed: "FRNetwork Connection Failed.",
  ReceiptConfirmation: "FRReceipt Confirmation",
  InvalidEmail: "FRInvalid Email",
  PleaseEnterValidEmail: "FRPlease enter valid email",
  AreYouSureYouWantToReprintThisReceipt:
    "FRAre you sure you want to reprint this receipt?",
  UnableToConnectPrinter: "FRUnable to connect printer",
  ReprintCompleted: "FRReprint Completed",
  EnterValidReason: "FREnter Valid Reason",
  TransactionCompleted: "FRTransaction Completed",
  AllDataWillBeLostWhenYouAreLoggedOutAsOwnerWouldYouLikeToProceed:
    "FRAll data will be lost when you are logged out as owner. Would you like to proceed?",
  Logout: "FRLogout",
  AttendantAlreadyExists: "FRAttendant Already Exists",
  SuccessfullyUpdatedAttendant: "FRSuccessfully updated attendant",
  PinCodeContainsSpecialCharacters: "FRPin code contains special characters",
  DeleteAttendant: "FRDelete Attendant",
  AreYouSureYouWantToDeleteAttendant:
    "FRAre you sure you want to delete attendant?",
  SuccessfullyDeletedAttendant: "FRSuccessfully Deleted Attendant",
  NoShiftsCreated: "FRNo Shifts Created",
  BluetoothConnectionFailed: "FRBluetooth Connection Failed",
  RoleError: "FRRole Error",
  UnableToGoToListingIfYouAreTheOwnerReLogInAsOwnerInOrderToProceed:
    "FRUnable to go to listing. If you are the owner, re log-in as owner in order to proceed",
  UnableToRegisterEmailAddressIsAlreadyTaken:
    "FRUnable to register. Email address is already taken",
  UnableToRegisterConnectionFailed: "FRUnable to register. Connection failed",
  EmailAlreadyExists: "FREmail Already Exists",
  EmailIsAvailable: "FREmail is available",
  InputAValidEmail: "FRInput a valid email",
  OpenShift: "FROpen Shift",
  InputValidRole: "FRInput Valid Role",
  SuccessfullyDeletedRole: "FRSuccessfully Deleted Role",
  DeleteRole: "FRDelete Role",
  AreYouSureYouWantToDeleteRole: "Are you sure you want to delete role?",
  SuccessfullyAddedRole: "FRSuccessfully Added Role",

  //Actual Receipts
  Cashier: "FRCashier: ",
  TransactionNo: "FRTransaction No.:",
  Qty: "FRQty",
  Purchases: "FRPurchases",
  TotalAmount: "FRTotal Amount",
  ThisServesAsYour: "FRThis serves as your",
  OfficialReceipt: "FROfficial Receipt",
  POSProvider: "FRPOS Provider:\n",
  AccredNo: "FRAccred. No.: \n",
  DateIssued: "FRDate Issued: \n",
  ValidUntil: "FRValid Until: \n\n",
  ThisReceiptShallBeValidFor: "FRTHIS RECEIPT SHALL BE VALID FOR\n",
  FiveYearsFromTheDateOf: "FRFIVE(5) YEARS FROM THE DATE OF\n",
  ThePermitToUse: "FRTHE PERMIT TO USE\n",
  FromDateMustBeGreaterThanOrEqualToDate:
    "FR(From) date must be greater than or equal (To) date",
  NoItemSalesFrom: "FRNo Item Sales from",
  Date: "FRDate",
  Type: "FRType",
  PrintedBy: "FRPrinted by",
  Closed: "FRClosed",
  PrintedOn: "FRPrinted on",
  Change: "FRChange",
  XRreading: "FRX Reading",
  Language: "FRLanguage",
  PleaseRestartTheApplicationToUpdateLanguage:
    "FRPlease restart the application to update language",
  AlreadyUpToDate: "Already up to date",
  SyncSuccessful: "Sync Successful",
  UnableToSync: "Unable to sync",
  InvalidUrl: "Invalid URL",
  CompanySettingsSaved: "Company Settings Saved",
  RestoreDefault: "Restore Default",
  AreYouSureYouWantToRestoreDefaultSettings:
    "Are you sure you want to restore default settings?",
  DefaultSettingsRestored: "Default Settings Restored",
};
